import Quill from 'quill';

const embedBlotName = 'deleteButton';
const BlockEmbedHtml = Quill.import('blots/block/embed');

class EmbedHtmlBlot extends BlockEmbedHtml {

  static create({ value, shortId }) {
    const node = super.create();

    node.innerText = value;
    node.setAttribute('class', 'custom-delete-btn');
    node.setAttribute('id', `blot-custom-del-btn-id---${shortId}`);
    node.setAttribute('contenteditable', 'false');

    node.addEventListener("click", (event) => {
      event.target.parentElement.querySelector(`#blot-custom-id---${event.target.id.split('---').at(-1)}`).remove();
      event.target.parentElement.querySelector(`#blot-custom-del-btn-id---${event.target.id.split('---').at(-1)}`).remove();
    });

    return node;
  }

  static value(node) {
    return { value: node.innerText, shortId: node.id.split('---').at(-1) };
  }
}

EmbedHtmlBlot.blotName = embedBlotName;
EmbedHtmlBlot.tagName = 'i';
Quill.register(EmbedHtmlBlot);